import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { QUOTE_QUESTIONS } from "../../AppConstants";

const rules = {
    hasInsurance: 'required',
    currentInsuranceDetails: 'required',
    beenUninsured: [
        'required_if:currentInsuranceDetails,' + QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.OWN_POLICY,
        'required_if:currentInsuranceDetails,' + QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.ANOTHER_POLICY_PROOF_OF_INSURANCE,
    ],
    uninsuredPeriod: [
        { required_if: ['beenUninsured', QUOTE_QUESTIONS.CURRENT_INSURANCE.WAS_UNINSURED.WITHIN_SIX_MONTHS] },
        { required_if: ['beenUninsured', QUOTE_QUESTIONS.CURRENT_INSURANCE.WAS_UNINSURED.WITHIN_THREE_YEARS] },
        { required_if: ['currentInsuranceDetails', QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.OVERSEAS] },
        { required_if: ['currentInsuranceDetails', QUOTE_QUESTIONS.CURRENT_INSURANCE.CURRENT_INSURANCE_DETAILS.POLICY_EXPIRED_LESS_30_DAYS] }
    ]
};

export const allFieldsValidation = (data) => {
    return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
};